import { createFileRoute } from '@tanstack/react-router';
import { Alert, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { PlatformRole, hasRole, useSession } from '../auth/session';
import { GroupsScreen } from '../features/groups/GroupsScreen';
import { BackLink } from '../components/BackLink';

export const Route = createFileRoute('/tenants_/$tenantId_/groups')({
  component: GroupsPage,
});

function GroupsPage() {
  const { t } = useTranslation('tenants');
  const { tenantId } = Route.useParams();
  const { data: session } = useSession();

  const canAdmin = hasRole(session, PlatformRole.TenantAdmin, tenantId);
  const canView = hasRole(session, PlatformRole.Viewer, tenantId);

  return (
    <Stack gap="sm">
      <BackLink to="/tenants/$tenantId" params={{ tenantId }} search={{ tab: 'settings' }} />

      {!canView ? (
        <Alert color="red" title={t('noAccessGroupsTitle')}>
          {t('noRoleBody')}
        </Alert>
      ) : (
        <>
          {!canAdmin && (
            <Alert color="blue" variant="light" title={t('readOnlyTitle')}>
              {t('readOnlyGroupsBody')}
            </Alert>
          )}
          <GroupsScreen tenantId={tenantId} canAdmin={canAdmin} />
        </>
      )}
    </Stack>
  );
}
